import { gql } from '@apollo/client'

const CATEGORY_MENU_QUERY = gql`
  query CATEGORY_MENU_QUERY {
    newsPage: pages(first: 1, where: { name: "news" }) {
      nodes {
        acfNews {
          categoriesMenu {
            nodes {
              ... on Category {
                name
              }
            }
          }
        }
      }
    }
  }
`

export default CATEGORY_MENU_QUERY
